import React from "react"
import {useAccessToken} from "../../../services/auth"
import useAsyncResultIdle from "../../../hooks/useAsyncResultIdle"
import {BusinessProductApplication, patchBusinessProductApplication} from "../../../resources/productApplication"
import {ErrorDocument} from "../../../resources/common"
import ConfirmationModalContent from "../../ReevaluateApplication/ReevaluateConfirmationModal/ConfirmationModalContent"
import {ReevaluatedBusinessProductApplicationData} from "../Forms/ReevaluateBusinessProductApplicationForm/ReevaluateBusinessProductApplicationForm"

export default function ReevaluateBusinessProductApplicationConfirmationModal(props: {
	close: () => void
	onSuccess: () => void
	onError: (error?: ErrorDocument) => void
	application: BusinessProductApplication
	reevaluatedData: ReevaluatedBusinessProductApplicationData
}) {
	const {close, onSuccess, onError, application, reevaluatedData} = props
	const accessToken = useAccessToken()
	const [updateRequest, setUpdateRequest] = useAsyncResultIdle(patchBusinessProductApplication)

	const handleSubmit = (reason: string) => {
		const data = {
			dba: reevaluatedData.dba,
			address: reevaluatedData.address,
			operatingAddress: reevaluatedData.operatingAddress,
			phone: reevaluatedData.phone,
			stateOfIncorporation: reevaluatedData.stateOfIncorporation,
			businessVertical: reevaluatedData.businessVertical,
			yearOfIncorporation: reevaluatedData.yearOfIncorporation,
			website: reevaluatedData.website,
			numberOfEmployees: reevaluatedData.numberOfEmployees,
			annualRevenue: reevaluatedData.annualRevenue,
			cashFlow: reevaluatedData.cashFlow,
			industry: reevaluatedData.industry,
			countriesOfOperation: reevaluatedData.countriesOfOperation,
			contact: reevaluatedData.contact,
		}

		setUpdateRequest(accessToken, application.id, data, reason)
	}

	return (
		<ConfirmationModalContent
			state={updateRequest}
			close={close}
			onSubmit={handleSubmit}
			onSuccess={onSuccess}
			onError={onError}
			enableReevaluateApplication={true}
		/>
	)
}
